import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { string } from "yup";

import { SexInputField } from "./SexInputField";
import { SexSummaryField } from "./SexSummaryField";
import { FieldType } from "../types";

export function SexField(
  field: components["schemas"]["SexCheckField"]
): FieldType<components["schemas"]["SexCheckField"]> {
  return {
    field,
    inputElement: <SexInputField key={field.name} field={field} />,
    summaryElement: () => <SexSummaryField key={field.name} field={field} />,
    initialValue: field.value,
    schema: sexFieldSchema,
  };
}

export const sexFieldSchema = string().required(t("This field is required"));
